export default {
  "content": "<g fill=\"#1F4698\" fill-rule=\"evenodd\"><path d=\"M19.726 18.784h2.761v-6.261h-2.761zM1.5 12.524v9.391h.013V24h20.974v-2.608h-9.116V14.35H10.61v7.042H4.261v-8.868zm10.49-3.905c.914 0 1.654.7 1.654 1.562 0 .862-.74 1.562-1.654 1.562-.913 0-1.654-.7-1.654-1.562 0-.863.74-1.562 1.654-1.562\"/><path d=\"M11.99 2.623c4.27-.007 7.735 3.256 7.743 7.288v.006H22.5C22.5 4.44 17.8 0 12 0S1.5 4.44 1.5 9.917h2.767c.004-4.027 3.46-7.291 7.723-7.294\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};